import { keepPreviousData } from '@tanstack/react-query';
import {
    RoleFilters,
    RoleGetResult,
    StringFilterType,
    useRepositoryMutation,
    useRepositoryQuery,
} from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';
import { showSuccessAlert, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { downloadFile } from '@mews-commander/utils';

export const useRolesListData = (tableState: TableState<RoleGetResult, RoleFilters>) => {
    const { filters, sort, pagination, globalFilters } = tableState;

    return useRepositoryQuery(
        'roles',
        'getAll',
        {
            filters,
            sort,
            pagination,
            ...(globalFilters.search && {
                globalSearchFilter: { value: globalFilters.search, filterType: StringFilterType.Contains },
            }),
        },
        {
            placeholderData: keepPreviousData,
        }
    );
};

export const useExportRoles = () =>
    useRepositoryMutation('roles', 'getAllExport', {
        transformParams: (_: void) => ({}),
        onSuccess: (data) => {
            downloadFile(data);
            showSuccessAlert({
                description: <LocalizedText textKey={TextKey.FileDownloadWillBegin} />,
                title: <LocalizedText textKey={TextKey.ExportCompleted} />,
            });
        },
    });
